import React, { FC } from 'react'

import { Photos, Photo } from 'components/page/ForeignProfile/common.types'
import { ForeignPhotoContext } from 'components/page/ForeignProfile/ForeignProfile.constants'
import { WrapperDesktop } from 'components/page/ForeignProfile/ForeignProfile.styled'
import { ForeignProfileHappyBirthdayMobileLoadable } from 'components/page/ForeignProfile/ForeignProfileHappyBirthday/ForeignProfileHappyBirthdayMobileLoadable'
import { PhotoImageHugeWithoutLink } from 'components/page/ForeignProfile/Photos/PhotoImageHugeWithoutLink'
import { useForeignPhotoContext } from 'components/page/ForeignProfile/Photos/Photos.hooks'
import { ImagesWrapper } from 'components/page/ForeignProfile/Photos/Photos.styled'
import { MainPhoto } from 'components/page/ForeignProfile/Photos/PhotosTile/MainPhoto'
import { PhotosTile } from 'components/page/ForeignProfile/Photos/PhotosTile/PhotosTile'
import { PhotosTileLastBlock } from 'components/page/ForeignProfile/Photos/PhotosTile/PhotoTileLastBlock/PhotosTileLastBlock'
import { GQLGender } from 'generated-graphql/graphql'

export const ForeignProfilePhotos: FC<{
  userId: string
  gender: GQLGender
  isBirthdayToday: boolean
  hasIncognito: boolean
  mainPhoto: Photo
  secondaryPhotos: Photos
  restPhotos: Photos
}> = ({
  userId,
  gender,
  isBirthdayToday,
  hasIncognito,
  mainPhoto,
  secondaryPhotos,
  restPhotos,
}) => {
  const foreignContextValue = useForeignPhotoContext(hasIncognito)

  if (!mainPhoto && secondaryPhotos.length === 0) {
    return (
      <ForeignPhotoContext.Provider value={foreignContextValue}>
        <ImagesWrapper>
          <PhotoImageHugeWithoutLink gender={gender} userId={userId} />
          {isBirthdayToday && <ForeignProfileHappyBirthdayMobileLoadable />}

          {restPhotos.length > 0 && (
            <WrapperDesktop>
              <PhotosTileLastBlock restPhotos={restPhotos} />
            </WrapperDesktop>
          )}
        </ImagesWrapper>
      </ForeignPhotoContext.Provider>
    )
  }

  if (mainPhoto && secondaryPhotos.length === 0) {
    return (
      <ForeignPhotoContext.Provider value={foreignContextValue}>
        <ImagesWrapper>
          <MainPhoto mainPhoto={mainPhoto} />
          {isBirthdayToday && <ForeignProfileHappyBirthdayMobileLoadable />}
          {restPhotos.length > 0 && (
            <WrapperDesktop>
              <PhotosTileLastBlock restPhotos={restPhotos} />
            </WrapperDesktop>
          )}
        </ImagesWrapper>
      </ForeignPhotoContext.Provider>
    )
  }

  if (mainPhoto && secondaryPhotos.length > 0) {
    return (
      <ForeignPhotoContext.Provider value={foreignContextValue}>
        <ImagesWrapper>
          <MainPhoto mainPhoto={mainPhoto} />
          {isBirthdayToday && <ForeignProfileHappyBirthdayMobileLoadable />}
          <PhotosTile photos={secondaryPhotos} />
          {restPhotos.length > 0 && (
            <WrapperDesktop>
              <PhotosTileLastBlock restPhotos={restPhotos} />
            </WrapperDesktop>
          )}
        </ImagesWrapper>
      </ForeignPhotoContext.Provider>
    )
  }

  return (
    <ForeignPhotoContext.Provider value={foreignContextValue}>
      <ImagesWrapper>
        <PhotoImageHugeWithoutLink gender={gender} userId={userId} />
        {isBirthdayToday && <ForeignProfileHappyBirthdayMobileLoadable />}
      </ImagesWrapper>
    </ForeignPhotoContext.Provider>
  )
}
